import Entity from "./entity";
import Description from "./description";

class Item {
  static rustic(glyph, name, description) {
    return Item.make("Rustic", glyph, name, description);
  }

  static ancient(glyph, name, description) {
    return Item.make("Ancient", glyph, name, description);
  }

  static mundane(glyph, name, description) {
    return Item.make("Mundane", glyph, name, description);
  }

  static precious(glyph, name, description) {
    return Item.make("Precious", glyph, name, description);
  }

  static creepy(glyph, name, description) {
    return Item.make("Creepy", glyph, name, description);
  }

  static gothic(glyph, name, description) {
    return Item.make("Gothic", glyph, name, description);
  }

  static arcane(glyph, name, description) {
    return Item.make("Arcane", glyph, name, description);
  }

  static ramshackle(glyph, name, description) {
    return Item.make("Ramshackle", glyph, name, description);
  }

  static make(quality, glyph, name, description) {
    return new Entity(null, null, glyph, name, {
      description: new Description(description),
      item: new Item(quality)
    });
  }

  constructor(quality) {
    this.quality = quality;
  }
}

export default Item;
